import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Config
import colors from "../../config/colors";

// Components
import Text from "../Text";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: ({ background }) => background,
    padding: theme.spacing(3, 4),
    gap: theme.spacing(1)
  },
  track: {
    width: "100%",
    height: 10,
    borderRadius: 5,
    backgroundColor: colors.white
  },
  fill: {
    height: "100%",
    borderRadius: 5,
    width: ({ progress }) => `${progress * 100}%`,
    background: ({ isIntel }) =>
      isIntel
        ? "transparent linear-gradient(76deg, #452CFC 0%, #23167E 100%) 0% 0% no-repeat padding-box"
        : "transparent linear-gradient(90deg, #3ACCE1 0%, #14FF65 100%) 0% 0% no-repeat padding-box"
  },
  bottomRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1)
  },
  text: {
    fontFamily: ["Open Sans", "sans-serif"].join(","),
    fontSize: 14,
    lineHeight: 1.3,
    color: colors.riverBed
  },
  titleText: {
    fontFamily: ["Open Sans", "sans-serif"].join(","),
    fontSize: 14,
    lineHeight: 1.3,
    color: colors.riverBed,
    textTransform: "uppercase"
  }
}));

// Purely presentational: title + progress track/fill + score copy, with an
// optional action (e.g. CaseInfoCard's Share/Ok button) rendered alongside
// the copy. Callers that don't need an action (e.g. the cases list cards)
// just omit children.
const EvidenceScoreBar = ({ score, isIntel, children }) => {
  const classes = useStyles({
    progress: score.progress,
    background: score.background,
    isIntel
  });

  return (
    <div className={classes.root}>
      <Text
        text="casesPage.caseCard.progressScoreBar.title"
        type="contentLabel3"
        className={classes.titleText}
      />
      <div className={classes.track}>
        <div className={classes.fill} />
      </div>
      <div className={classes.bottomRow}>
        <Text text={score.textKey} type="body1" className={classes.text} />
        {children}
      </div>
    </div>
  );
};

EvidenceScoreBar.propTypes = {
  score: PropTypes.shape({
    background: PropTypes.string,
    progress: PropTypes.number,
    textKey: PropTypes.string
  }).isRequired,
  isIntel: PropTypes.bool,
  children: PropTypes.node
};

EvidenceScoreBar.defaultProps = {
  isIntel: false,
  children: null
};

export default EvidenceScoreBar;
